import { ofType } from "redux-observable";
import { of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { TypeActionReconnectAfterLogin } from "./actionReconnectAfterLogin";
export var epicDisconnectedByLogin = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionReconnectAfterLogin.DisconnectedByLogin), switchMap(function () {
        deps.netDisableConnections();
        return of(actionModalOpen(IdModal.DisconnectedByLogin));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/reconnect-after-login/epicDisconnectedByLogin.ts
// module id = 2124
// module chunks = 3